import { Component, OnInit } from '@angular/core';
import { RotinaService } from '../rotina.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { Reincidencia } from '../../comum/modelos/reincidencia';
import { Data } from '../../comum/data/data';
import { FiltroReincidencia } from '../../comum/modelos/filtro-reincidencia';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { OcorrenciasService } from '../../ocorrencias/ocorrencias.service';

@Component({
    selector: 'app-lista-reincidencias',
    templateUrl: './lista-reincidencias.component.html',
    styleUrls: ['./lista-reincidencias.component.css']
})
export class ListaReincidenciasComponent implements OnInit {

    reincidenciasRotina: Reincidencia[];
    reincidenciasOcorrencia: Reincidencia[];
    statusCode: number;
    filtroReincidencia: FiltroReincidencia;
    public paginacaoRotina: Paginacao;
    public paginacaoOcorrencia: Paginacao;
    public evento: Evento;

    public loading = false;

    constructor (
        private _rotinaService: RotinaService,
        private _ocorrenciaService: OcorrenciasService,
        private _comumService: ComumService,
        private data: Data) {
        this.reincidenciasRotina = new Array<Reincidencia>();
        this.reincidenciasOcorrencia = new Array<Reincidencia>();
        this.filtroReincidencia = new FiltroReincidencia();
        this.paginacaoRotina = new Paginacao();
        this.paginacaoOcorrencia = new Paginacao();
        this.paginacaoRotina.itens = 5;
        this.paginacaoRotina.page = 1;
        this.paginacaoRotina.id = 'rotina';
        this.paginacaoOcorrencia.itens = 5;
        this.paginacaoOcorrencia.page = 1;
        this.paginacaoOcorrencia.id = 'ocorrencia';
        this.evento = this._comumService.evento;
        this.loading = false;
        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }
    }

    ngOnInit() {
        this.loading = true;
        this.filtroReincidencia = this.data.storage.filtroReincidencia;
        forkJoin(this._rotinaService.obterReincidenciasHttp(this.filtroReincidencia)
        , this._ocorrenciaService.obterReincidenciasHttp(this.filtroReincidencia))
        .subscribe(([reincidenciasRotinas, reincidenciasOcorrencias]) => {
            this.reincidenciasRotina = reincidenciasRotinas.body;
            this.reincidenciasOcorrencia = reincidenciasOcorrencias.body;
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/lista-reincidencias/lista-reincidencias.component.ts